import { render, staticRenderFns } from "./ReserveSetup.vue?vue&type=template&id=e2b237e6&"
import script from "./ReserveSetup.vue?vue&type=script&lang=js&"
export * from "./ReserveSetup.vue?vue&type=script&lang=js&"
import style0 from "./ReserveSetup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports